import React, { FC, useState } from 'react';

import { chakra, Flex as ChakraFlex, useMultiStyleConfig } from '@chakra-ui/react';
import { EventProps } from 'react-big-calendar';
import moment from 'moment';

import { CalendarPopover } from './CalendarPopover';

import { Event } from '../component';

export interface CalendarWeekEventProps extends EventProps<Event> {
  canEdit: boolean;
  onEdit: (event: Event) => void;
  onDelete: (event: Event) => void;
}

export const CalendarWeekEvent: FC<CalendarWeekEventProps> = ({ event, canEdit, onEdit, onDelete }) => {
  const { 'calendar-week-event': calendarWeekEventStyles } = useMultiStyleConfig('PTCalendar', {});

  const [isOpen, setIsOpen] = useState(false);

  return (
    event && (
      <CalendarPopover
        event={event}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onEdit={(event) => onEdit(event)}
        onDelete={(event) => onDelete(event)}
      >
        <ChakraFlex sx={calendarWeekEventStyles} onClick={() => canEdit && setIsOpen(true)}>
          <chakra.p isTruncated={true} fontWeight="pt-bold">
            {moment(event.start).format('HH:mm')} - {moment(event.end).format('HH:mm')}
          </chakra.p>
          <chakra.p isTruncated={true}>{event.title}</chakra.p>
        </ChakraFlex>
      </CalendarPopover>
    )
  );
};
